module.exports = __webpack_public_path__ + "img/participants.af9b9a61.svg";